import { Check, Clock, X } from "lucide-react";
import { cn } from "../../../lib/utils";
import { LastStage, Stage } from "../types";

const STAGE_LABELS: Record<Stage, string> = {
  arquivos_prontos: "Arquivos prontos",
  enviada_wts: "Enviada (WTS)",
  aceite: "Aceite",
  liquidado: "Liquidado",
  comprado: "Comprado",
  baixado: "Baixado",
};

const STAGE_ORDER: Stage[] = [
  "arquivos_prontos",
  "enviada_wts",
  "aceite",
  "liquidado",
  "comprado",
  "baixado",
];

interface StageStepperProps {
  lastStage: LastStage;
  // quando false, o estágio "arquivos_prontos" não é considerado alcançado
  // (usado na visão individual, onde o ponto de partida é o envio)
  startFromEnviada?: boolean;
}

export function StageStepper({ lastStage, startFromEnviada }: StageStepperProps) {
  const stages = startFromEnviada
    ? STAGE_ORDER.filter((s) => s !== "arquivos_prontos")
    : STAGE_ORDER;

  const notSent = lastStage === "nao_enviada";
  const reachedIndex = notSent
    ? -1
    : stages.indexOf(lastStage as Stage);

  return (
    <div className="flex flex-wrap items-center gap-2">
      {stages.map((stage, idx) => {
        const reached = reachedIndex >= idx;
        const isCurrent = reachedIndex === idx;
        // estágio onde parou no caso "não enviada": o primeiro (envio)
        const stoppedHere = notSent && idx === 0;

        return (
          <div key={stage} className="flex items-center gap-2">
            <div
              className={cn(
                "flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors",
                reached &&
                  "border-emerald-500/40 bg-emerald-50 text-emerald-700",
                stoppedHere &&
                  "border-destructive/50 bg-destructive/10 text-destructive",
                !reached &&
                  !stoppedHere &&
                  "border-muted bg-muted/40 text-muted-foreground"
              )}
            >
              {reached ? (
                <Check className="h-3 w-3" />
              ) : stoppedHere ? (
                <X className="h-3 w-3" />
              ) : (
                <Clock className="h-3 w-3" />
              )}
              {stoppedHere ? "Não enviada" : STAGE_LABELS[stage]}
              {isCurrent && (
                <span className="ml-1 rounded-sm bg-emerald-600 px-1 text-[10px] text-white">
                  atual
                </span>
              )}
            </div>
            {idx < stages.length - 1 && (
              <div
                className={cn(
                  "h-px w-4",
                  reachedIndex > idx ? "bg-emerald-400" : "bg-muted"
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

export { STAGE_LABELS };
